import PropTypes from 'prop-types';

import ExternalSourceShape from './ExternalSourceShape';
import ExternalDownloadShape from './ExternalDownloadShape';

export default PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(ExternalSourceShape).isRequired,
  download: ExternalDownloadShape,
}));



// WEBPACK FOOTER //
// ./src/components/ExternalLinksCollection/ExternalLinksShape.js